/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TestMfeRouteImport } from './routes/test-mfe'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BootRouteImport } from './routes/boot'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginCallbackRouteImport } from './routes/login.callback'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const TestMfeRoute = TestMfeRouteImport.update({
  id: '/test-mfe',
  path: '/test-mfe',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BootRoute = BootRouteImport.update({
  id: '/boot',
  path: '/boot',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => LoginRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/access-denied': typeof AccessDeniedRoute
  '/boot': typeof BootRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/not-found': typeof NotFoundRoute
  '/test-mfe': typeof TestMfeRoute
  '/welcome': typeof WelcomeRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/access-denied': typeof AccessDeniedRoute
  '/boot': typeof BootRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/not-found': typeof NotFoundRoute
  '/test-mfe': typeof TestMfeRoute
  '/welcome': typeof WelcomeRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/access-denied': typeof AccessDeniedRoute
  '/boot': typeof BootRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/not-found': typeof NotFoundRoute
  '/test-mfe': typeof TestMfeRoute
  '/welcome': typeof WelcomeRoute
  '/login/callback': typeof LoginCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/access-denied'
    | '/boot'
    | '/login'
    | '/logout'
    | '/not-found'
    | '/test-mfe'
    | '/welcome'
    | '/login/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/access-denied'
    | '/boot'
    | '/login'
    | '/logout'
    | '/not-found'
    | '/test-mfe'
    | '/welcome'
    | '/login/callback'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/access-denied'
    | '/boot'
    | '/login'
    | '/logout'
    | '/not-found'
    | '/test-mfe'
    | '/welcome'
    | '/login/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AccessDeniedRoute: typeof AccessDeniedRoute
  BootRoute: typeof BootRoute
  LoginRoute: typeof LoginRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  NotFoundRoute: typeof NotFoundRoute
  TestMfeRoute: typeof TestMfeRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-mfe': {
      id: '/test-mfe'
      path: '/test-mfe'
      fullPath: '/test-mfe'
      preLoaderRoute: typeof TestMfeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boot': {
      id: '/boot'
      path: '/boot'
      fullPath: '/boot'
      preLoaderRoute: typeof BootRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof LoginRoute
    }
  }
}

interface LoginRouteChildren {
  LoginCallbackRoute: typeof LoginCallbackRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginCallbackRoute: LoginCallbackRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AccessDeniedRoute: AccessDeniedRoute,
  BootRoute: BootRoute,
  LoginRoute: LoginRouteWithChildren,
  LogoutRoute: LogoutRoute,
  NotFoundRoute: NotFoundRoute,
  TestMfeRoute: TestMfeRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
